import React, { Component } from "react";
import { func, string, bool, shape, number } from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import * as i18nUtils from "util/i18n";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as desktopSelectors } from "reducers/desktop";
import { actions, selectors } from "reducers/widgets";

import WidgetLoading from "pages/_components/WidgetLoading";
import NoProduct from "pages/desktop/widgets/_components/NoProduct";
import Button from "pages/_components/Button";
import Slider from "react-slick";

class WidgetList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        children: func.isRequired,
        item: func,
        keyExtractor: func,
        name: string.isRequired,
        shouldMapList: bool,
        list: shape({}).isRequired,
        isFetching: bool,
        isEditable: bool,
        activeEnvironment: shape({}),
        isDesktop: bool.isRequired,
        limitTo: number,
    };

    static defaultProps = {
        shouldMapList: true,
        keyExtractor: () => {},
        item: null,
        isFetching: false,
        isEditable: false,
        activeEnvironment: {},
        limitTo: 0,
    };

    componentDidMount() {
        const { dispatch, name } = this.props;
        dispatch(actions.listRequest(name));
    }

    renderItem = (item) => {
        const { item: Item, keyExtractor } = this.props;

        return (
            <div role="menu" className="grid-table products-list">
                <Item key={keyExtractor(item)} {...item} />
            </div>
        );
    };

    renderList = () => {
        const { list, isFetching, name, shouldMapList, activeEnvironment, isEditable, limitTo } = this.props;

        if (!(list.length || isFetching)) {
            let buttonData;
            let button;

            const isSubFormAvailable = (formName) =>
                !!activeEnvironment.forms[name.toLowerCase()].find(({ idForm }) => idForm === formName);

            if (activeEnvironment?.forms?.[name.toLowerCase()]) {
                if (isSubFormAvailable("accountOpening")) {
                    buttonData = {
                        text: "accounts.new",
                        pushPath: "/accounts/requestForm/",
                    };
                } else if (isSubFormAvailable("CreditCardRequest")) {
                    buttonData = {
                        text: "creditCard.new",
                        pushPath: "/form/creditCardRequest/",
                    };
                } else if (isSubFormAvailable("requestLoan")) {
                    buttonData = {
                        text: "loan.new",
                        pushPath: "/form/requestLoan/",
                    };
                }
            }

            if (buttonData) {
                const handlerOnClick = () => {
                    const { dispatch } = this.props;
                    dispatch(push(buttonData.pushPath));
                };

                button = (
                    <Button
                        className="btn btn-primary btn-small"
                        block={false}
                        onClick={handlerOnClick}
                        label={buttonData.text}
                    />
                );
            }

            return (
                <article className="table table--products" aria-hidden={isEditable}>
                    <NoProduct
                        text={`desktop.widgets.${name}.empty`}
                        imagePath={`images/coloredIcons/${name}.svg`}
                        button={button}
                    />
                </article>
            );
        }

        if (!shouldMapList) {
            return list;
        }
        const ArrowLeft = (props) => (
            <Button
                {...props}
                image="images/figma/icon/arrow-left-filled.svg"
                bsStyle="btn-rotate"
                aria-label={i18nUtils.get("Anterior")}
            />
        );
        const ArrowRight = (props) => (
            <Button
                {...props}
                image="images/figma/icon/arrow-right-filled.svg"
                bsStyle="btn-rotate"
                aria-label={i18nUtils.get("Siguiente")}
            />
        );

        const settings = {
            draggable: true,
            infinite: false,
            initialSlide: 0,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            ...(list.length > 2 && {
                dots: true,
                nextArrow: <ArrowRight />,
                prevArrow: <ArrowLeft />,
            }),
            responsive: [
                {
                    breakpoint: 1366,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 0,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                        initialSlide: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        return (
            <>
                <WidgetLoading loading={!list.length && isFetching}>
                    <Slider {...settings}>
                        {limitTo ? list.slice(0, limitTo).map(this.renderItem) : list.map(this.renderItem)}
                    </Slider>
                </WidgetLoading>
            </>
        );
    };

    render() {
        const { children } = this.props;

        return children(this.renderList());
    }
}

const mapStateToProps = (state, { name }) => {
    const { isFetching, data } = selectors.getWidget(state, name);

    return {
        isFetching,
        list: data[name],
        isEditable: desktopSelectors.getIsEditale(state),
        activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    };
};

export default connect(mapStateToProps)(WidgetList);
